import React, {FunctionComponent} from 'react';
import {Button, ButtonGroup, FormGroup} from '@blueprintjs/core';

import {Method} from './constants';

interface MethodInputProps {
  value: Method;
  disabled: boolean;
  onChange: (value: any) => void;
}

const MethodInput: FunctionComponent<MethodInputProps> = ({
  value,
  disabled,
  onChange,
}: MethodInputProps) => {
  return (
    <FormGroup className="method-input" label="Method" inline={true}>
      <ButtonGroup>
        <Button
          active={value === Method.APPEND}
          onClick={() => onChange(Method.APPEND)}
          text={Method.APPEND}
          disabled={disabled}
          outlined={true}
        />
        <Button
          active={value === Method.OVERWRITE}
          onClick={() => onChange(Method.OVERWRITE)}
          text={Method.OVERWRITE}
          disabled={disabled}
          outlined={true}
        />
      </ButtonGroup>
    </FormGroup>
  )
};

export default MethodInput;
